import React from "react"

import '../styles/pages/Home.css'

import Menu from "../components/Menu";
import Courses from "../components/Courses";
import WorkWith from "../components/WorkWith";
import YouSearch from "../components/YouSearch";
import Reviews from "../components/Reviews";
import BlogComponent from "../components/BlogComponent";
import Footer from "../components/Footer";


const Home = () => {

    return (
        <>
            <header className='home-header'>
                <Menu/>
            </header>
            <Courses/>
            <WorkWith/>
            <YouSearch/>
            <Reviews/>
            <BlogComponent/>
            <Footer/>
        </>
    );
}

export default Home;